import { request } from '../../../utils/request';

export interface CreateIndividualProfileParams {
  phone: string;
  dob: string;
  customer_type_id?: string; /// TODO: FIGURE THIS OUT LATER
  address_choice: {
    type: 'saved' | 'new';
    saved_address_id?: number;
    /**
     * Which table `saved_address_id` came from. Store-app pickers source from
     * `/sterling/kyc/addresses` (`wallet_addresses`), so we always send 'wallet'.
     * Defaults to 'wallet' below if the caller omits it.
     */
    source?: 'wallet' | 'user_address';
    new_address?: {
      street: string;
      street_line_2?: string;
      city: string;
      state: string;
      postal_code?: string;
      country: string;
      lga?: string;
    };
  };
}

export interface CreateIndividualProfileResponse {
  customer_id: number;
  success?: boolean;
}

export default async function createIndividualProfile(
  params: CreateIndividualProfileParams,
  authToken: string
): Promise<CreateIndividualProfileResponse> {
  const res = await request({
    url: '/sterling/kyc/individual',
    method: 'POST',
    formData: {
      address_choice: params.address_choice,
      user_provided_data: {
        phone: params.phone,
        dob: params.dob,
        customer_type_id: params.customer_type_id,
      },
    },
    headers: { Authorization: `Bearer ${authToken}` },
  });

  if (!res.customer_id)
    throw new Error(res.message || 'Failed to create profile');
  return res;
}
